module.exports = __webpack_public_path__ + "static/media/event5.cc2b46e5.jpg";